export const HideElementOnScrollEffectThreshold = {
  desktop: 508,
  mobile: 200,
};
